export default __webpack_public_path__ + "4e9de06ee72b6647624a84728f38695c.svg";